import { IACData, iacMenu as api } from 'st-app/api'
import { rootWindow } from 'common'

const allIACData: Record<string, IACData> = {};

export async function loadIACData(boid: string) {
    return new Promise<IACData>(async (resolve, reject) => {
        if (!boid) {
            reject();
        }
        else if (window !== rootWindow()) {
            resolve(await rootWindow().ST.LoadIACData(boid));
        }
        else {
            if (!allIACData[boid]) {
                allIACData[boid] = await api.LoadIntegratedActions(boid);
            }

            if (allIACData[boid]) {
                resolve(allIACData[boid]);
            }
        }
    });
}

// publish this method so we can access it on the root window
window.ST.LoadIACData = loadIACData;
